const websiteIds = require('lightning-common/lib/configuration/websiteIds.json');

module.exports = function isCanarySite(websiteId) {
    return (
        websiteId === websiteIds.qaintegration ||
        (websiteId >= 800000 && websiteId < 900000)
    );
};
